import React from 'react';
import PlayerCard from './PlayerCard';

const PlayerGrid = ({ players, refreshPlayers }) => {
  if (players.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">&#x1F3C0;</div>
        <h3>No prospects found</h3>
        <p>Try adjusting your search or class filter.</p>
      </div>
    );
  }

  return (
    <div className="player-grid">
      {players.map((player) => (
        <PlayerCard key={player.id} player={player} />
      ))}

      <style>{`
        .player-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
          gap: 12px;
          padding: 10px 0 40px;
        }
        @media (max-width: 840px) {
          .player-grid { grid-template-columns: 1fr; }
        }
        .empty-state {
          text-align: center;
          padding: 80px 20px;
          color: #8888aa;
        }
        .empty-icon { font-size: 3rem; margin-bottom: 12px; }
        .empty-state h3 { color: #ccc; margin-bottom: 6px; }
      `}</style>
    </div>
  );
};

export default PlayerGrid;
